export const getGroupConfigurationsData = (state) => state.groupConfigurations.groupConfigurations;
export const getLoadingStatus = (state) => state.groupConfigurations.loadingStatus;
export const getSavingStatus = (state) => state.groupConfigurations.savingStatus;
export const getErrorMessage = (state) => state.groupConfigurations.errorMessage;
